/**
 * LA PHRASE D'UN REFUS DU SERVEUR.
 * ============================================================================
 *
 * Un refus se dit en une phrase, jamais par un code. Trois motifs de droits
 * ont leur phrase (S:2451-2455, T5 « Le 403 motivé ») ; les cinq autres refus
 * et les indéterminés partagent la phrase neutre, délibérément : distinguer
 * « aucun lien » de « objet supprimé » donnerait un test d'existence sur les
 * équipements d'un autre client. Un code inconnu prend aussi la phrase neutre.
 *
 * Le motif arrive par `ErreurAlarmesV2.motif`, lu sous `detail.context`
 * (`services/appel.ts`).
 */
import {
    CODE_FERMEE,
    CODE_INDISPONIBLE,
} from "@modules/alarmes-v2/services/appel"

/** Les trois motifs de droits qui ont leur phrase. */
const PHRASE_DU_MOTIF: Record<string, string> = {
    refus_role_insuffisant: "alarmesV2.refus.role",
    refus_hors_perimetre: "alarmesV2.refus.perimetre",
    refus_source_sans_batiment: "alarmesV2.refus.sansBatiment",
}

/** La phrase neutre. */
const NEUTRE = "alarmesV2.refus.neutre"

/**
 * La clé de la phrase d'un refus.
 * @param refus - le code et, pour un refus de droits, le motif
 */
export function cleDuRefus(refus: { code: string; motif?: string }): string {
    if (refus.code === CODE_INDISPONIBLE) return "alarmesV2.refus.indisponible"
    if (refus.code === CODE_FERMEE) return "alarmesV2.refus.fermee"
    return (refus.motif && PHRASE_DU_MOTIF[refus.motif]) || NEUTRE
}
